// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"714":"9b80ff17","715":"e8b7589b","835":"2c520d63"}[chunkId] + ".chunk.js";
};